// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__298ls","col":"CardReaderDesc_col__1xm0D","label":"CardReaderDesc_label__2T4Db"};